<template>
    <div class="solutions-area ptb-100" id="serviciile-noastre">
        <div class="container">
            <div class="section-title">
                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Servicii</span>
                <h2>Uneltele Noastre pentru Afacerea Ta</h2>
                <p>Soluții software pentru a transforma ideile tale în realitate.</p>
            </div>
            <!-- Group 1: Optimizăm Prezentul -->
            <div class="text-left">
                <h3>Optimizăm Prezentul</h3>
                <p>Soluții robuste pentru a eficientiza operațiunile curente, a reduce costurile și a crește productivitatea.</p>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-cog'  ></i>  
                        </div>
                        <h3>Dezvoltare ERP & CRM Custom</h3>
                        <p>Construim sisteme ERP personalizate care centralizează operațiunile, automatizează procesele și îți oferă o viziune clară, în timp real, asupra întregii afaceri. Cu ajutorul CRM centralizezi toate interacțiunile, de la primul contact la suportul post-vânzare, transformând datele în relații de lungă durată.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-scan'  ></i> 
                        </div>
                        <h3>Managementul Depozitului (WMS)</h3>
                        <p>Stocurile greu de urmărit, erorile la preluarea comenzilor și spațiul ineficient folosit în depozit îți încetinesc operațiunile. Dezvoltăm platforme WMS inteligente care îți oferă o hartă digitală a depozitului, optimizează rutele operatorilor și automatizează recepția și livrarea mărfii.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-buildings'  ></i>   
                        </div>
                        <h3>Business To Business (B2B)</h3>
                        <p>Procesarea manuală a comenzilor de la parteneri prin telefon sau email este lentă, costisitoare și predispusă la erori. Creăm platforme B2B (business-to-business) securizate, care oferă clienților tăi de afaceri o experiență de comandă self-service, disponibilă 24/7. Portalul se integrează perfect cu sistemul ERP și WMS, afișând în timp real stocuri, prețuri personalizate și istoricul comenzilor.</p>
                    </div>
                </div>
            </div>
            
            <!-- Group 2: Integrăm Viitorul -->
            <div class="text-right">
                <h3>Integrăm Viitorul</h3>
                <p>Platforme flexibile și conectate care îți pregătesc afacerea pentru creștere, inovație și noi piețe.</p>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-extension'  ></i>  
                        </div>
                        <h3>Aplicații Integrate</h3>
                        <p>Sistemele software din compania ta (contabilitate, gestiune, site) nu "vorbesc" între ele, forțându-ți echipa să introducă manual aceleași date în locuri multiple. Construim aplicații și "punți" digitale (integrări prin API) care unifică sistemele disparate într-un ecosistem fluid și automatizat.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-mobile-alt'  ></i> 
                        </div>
                        <h3>Aplicații Mobile</h3>
                        <p>Echipele tale sunt pe teren, iar clienții tăi sunt mereu în mișcare. Dezvoltăm aplicații mobile native (iOS și Android) sau cross-platform care extind funcționalitatea sistemelor tale direct pe smartphone-ul sau tableta utilizatorului, asigurând acces rapid la informații și operațiuni, oriunde și oricând.</p>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="single-solutions-box">
                        <div class="icon">
                            <i class='bx  bx-chip'  ></i>  
                        </div>
                        <h3>Inteligență Artificială (AI)</h3>
                        <p>Procesele repetitive și volumele mari de date îți limitează potențialul de creștere și capacitatea de a lua decizii rapide. Integrăm modele avansate de Inteligență Artificială direct în aplicațiile tale, automatizând sarcini complexe, extrăgând informații valoroase din date și creând experiențe personalizate pentru clienții tăi.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASServiciileNoastre'
}
</script>